import { createStagesSlice } from "./shared/createStagesSlice";

export const opportunityStagesSlice = createStagesSlice({
  name: "opportunityStages",
  hasDelete: true,
});

export const {
  setOpportunityStages,
  setEditableOpportunityStages,
  addStage,
  updateStage,
  removeStage,
  reorderStages,
  setIsEditing,
  setIsDirty,
  setIsLoading,
  setIsLocked,
  setLockedBy,
  setSelectedIndex,
  setGateMode,
  setEditableGateMode,
  setStageQuestions,
  addStageQuestion,
  removeStageQuestion,
  reorderStageQuestions,
} = opportunityStagesSlice.actions;

export default opportunityStagesSlice.reducer;
